import React from 'react';
import propTypes from 'prop-types';
import './index.css';

MoreStatus.propTypes = {
  status: propTypes.string.isRequired
};

MoreStatus.defaultProps = {
  status: 'init'
};
let more = {
  'init':'',
  'loading': '正在加载中...',
  'more':'加载更多',
  'end':'',
  'PENDING': '正在加载中...',
  'SUCCESS':'加载更多',
  'END':''
};

export default function MoreStatus(props) {
  let { status } = props;
  if(status === 'end' || status === 'END'){
    return null;
  }
  return <div className="more-status">{more[status]}</div>;
}




// WEBPACK FOOTER //
// ./src/components/MoreStatus/index.js